import { render, staticRenderFns } from "./PublicCategoryPage.vue?vue&type=template&id=332e98b0&scoped=true&"
import script from "./PublicCategoryPage.vue?vue&type=script&lang=js&"
export * from "./PublicCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332e98b0",
  null
  
)

export default component.exports